module.exports = __webpack_public_path__ + "static/media/download-to-excel-icon-0.52a7798f.jpg";